import { render } from "./checkbox.html?vue&type=template&id=800c243c&scoped=true&ts=true"
import script from "./checkbox.ts?vue&type=script&lang=ts"
export * from "./checkbox.ts?vue&type=script&lang=ts"

import "./checkbox.scss?vue&type=style&index=0&id=800c243c&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-800c243c"]])

export default __exports__